import { Link } from 'react-router-dom'
import CevLink from './CevLink'
import CevSocial from './CevSocial'
import lucid from '../../assets/img/cev/lucid.gif'
import bae from '../../assets/img/cev/bae.gif'
import bae2 from '../../assets/img/cev/bae2.gif'
import cold from '../../assets/img/cev/cold.gif'
import lost from '../../assets/img/cev/lost.gif'
import elevated from '../../assets/img/cev/elevated.gif'
import guthree from '../../assets/img/cev/guthree.gif'
import lazarus from '../../assets/img/cev/lazarus.gif'
import river from '../../assets/img/cev/river.gif'
import skull from '../../assets/img/cev/skull.gif'
import guidedFlow from '../../assets/img/cev/guided-flow.gif'
import mollette from '../../assets/img/cev/mollette.gif'
import soSmall from '../../assets/img/cev/so-small.gif'
import smooth from '../../assets/img/cev/smooth-metallic-object.gif'

const navLinks = [
  { title: 'lazarus', path: 'lazarus', gif: lazarus },
  { title: 'very cold', path: 'very-cold', gif: cold },
  { title: 'so small', path: 'so-small', gif: soSmall },
  { title: 'smooth metallic object', path: 'smooth-metallic-object', gif: smooth },
  { title: 'mollette', path: 'mollette', gif: mollette },
  { title: 'skull', path: 'skull', gif: skull },
  { title: 'river rips', path: 'river-rips', gif: river },
  { title: 'guided flow', path: 'guided-flow', gif: guidedFlow },
  { title: 'lucid flying', path: 'lucid-flying', gif: lucid },
  { title: 'guthree', path: 'guthree', gif: guthree },
  { title: 'elevated materials', path: 'elevated-materials', gif: elevated },
  { title: 'lost on a walk', path: 'lost-on-a-walk', gif: lost },
]

export default function CevNav({ hovered, setHovered }) {
  return (
    <div className={ `cev-nav ${ hovered ? 'hovered' : '' }` }>
      <Link to='/' className='bordered'>
        melting season
      </Link>
      
      <p>closed eye visual</p>

      { navLinks.map( (link, index) => 
        <CevLink
          key={ link.title }
          index={ index }
          title={ link.title }
          path={ link.path }
          gif={ link.gif }
          setHovered={ setHovered } />
      ) }

      <p>digital 7"</p>

      <CevLink
        index={ false }
        title='A. bae'
        path='bae'
        gif={ bae2 }
        setHovered={ setHovered } />

      <a
        className='indent'
        href='http://gong.meltingseason.net'
        onMouseEnter={ () => setHovered(bae) }
        onMouseLeave={ () => setHovered('') }>
        B. gong
      </a>

      <CevSocial />
    </div>
  )
}